import { LOCKER_FEE_TIERS, DIRECT_FEE_TIERS, FREE_SHIPPING_THRESHOLD } from './constants'

export const getLockerFee = (totalWeightKg) => {
  if (!totalWeightKg || totalWeightKg <= 0) return LOCKER_FEE_TIERS[0].fee
  for (const tier of LOCKER_FEE_TIERS) {
    if (totalWeightKg <= tier.maxKg) return tier.fee
  }
  return 119
}

export const getDirectFee = (totalWeightKg) => {
  if (!totalWeightKg || totalWeightKg <= 0) return DIRECT_FEE_TIERS[0].fee
  for (const tier of DIRECT_FEE_TIERS) {
    if (totalWeightKg <= tier.maxKg) return tier.fee
  }
  return 221.02
}

export const shippingFee = (method, totalWeightKg, subtotal) => {
  if (subtotal > FREE_SHIPPING_THRESHOLD) return 0
  if (method === 'direct') return getDirectFee(totalWeightKg)
  if (method === 'locker') return getLockerFee(totalWeightKg)
  return 0
}

export const getShippingDetails = (method, locker, addr) => {
  if (method === 'locker' && locker) {
    return `${locker.name} — ${locker.address}, ${locker.city}`
  }
  if (method === 'direct') {
    return `${addr.address}, ${addr.city}, ${addr.province}, ${addr.postalCode}`
  }
  if (method === 'collection') {
    return 'In-store collection'
  }
  return ''
}
